#import '../../../graphql/fragments/common.gql'

fragment Contract on ContractView {
  hasOffer
  contractNumber
  contractType
  legal {
    cid
    name {
      ...LangField
    }
  }
  status
  currencyISOCode
}

query AccommodationObjects2 {
  accommodationObjects2 {
    operations {
      canAdd
      onApprovalLimitExceeded {
        limit
      }
    }
    accommodationObjects {
      cid
      commonInformation {
        name {
          ...LangField
        }
        type
        category
        town
        status
      }
      contracts {
        ...Contract
      }
    }
  }
}

query AccomodationObjectDashboardInfo($accommodationObjectCid: String!) {
  accomodationObjectDashboardInfo(
    accomodationObjectDashboardInfoInput: { accommodationObjectCid: $accommodationObjectCid }
  ) {
    status
    supersetDomain
    guestToken
    dashboards {
      key
      value
    }
  }
}

query AccommodationObject2($accommodationObjectCid: String!) {
  accommodationObject2(accommodationObjectCid: $accommodationObjectCid) {
    cid
    commonInformation {
      name {
        ...LangField
      }
      type
      category
      town
      status
    }
    contacts {
      phone
      email
      webSite
      postalAddress {
        ...LangField
      }
    }
    contracts {
      ...Contract
    }
    operations {
      canAddContract
    }
    timeZoneOffsetMin
  }
}

query HotelCategorySuggestions($key: String, $maxResults: Int!) {
  hotelCategorySuggestions(suggestion: { key: $key, maxResults: $maxResults }) {
    cid
    name
  }
}

query HotelTypeSuggestions($key: String, $maxResults: Int!) {
  hotelTypeSuggestions(suggestion: { key: $key, maxResults: $maxResults }) {
    cid
    name
  }
}

query RoomTypeSuggestions($key: String!, $maxResults: Int!) {
  roomTypeSuggestions(suggestion: { key: $key, maxResults: $maxResults }) {
    cid
    name
  }
}

mutation AddAccommodationObjectRoomCategory(
  $baseQuantity: UnsignedShort!
  $extQuantity: UnsignedShort!
  $name: [LangStringInput!]!
  $description: [LangStringInput!]!
  $accommodationObjectCid: String!
  $roomTypeCid: String!
) {
  addAccommodationObjectRoomCategory(
    addAccommodationObjectRoomCategoryInput: {
      accommodationObjectCid: $accommodationObjectCid
      roomCategory: {
        roomTypeCid: $roomTypeCid
        name: $name
        description: $description
        seat: { baseQuantity: $baseQuantity, extQuantity: $extQuantity }
      }
    }
  ) {
    roomCategory {
      ...RoomCategoryView
    }
    errors {
      ...Error
      ...LockResourceError
    }
  }
}

mutation EditAccommodationObjectRoomCategory($accommodationObjectRoomCategoryCid: String!) {
  editAccommodationObjectRoomCategory(
    editAccommodationObjectRoomCategoryInput: {
      accommodationObjectRoomCategoryCid: $accommodationObjectRoomCategoryCid
    }
  ) {
    roomCategory {
      cid
      operations {
        delete
        edit
        fullEdit
      }
      isActive
    }
    errors {
      ...LockResourceError
    }
  }
}

mutation CancelEditAccommodationObjectRoomCategory($accommodationObjectRoomCategoryCid: String!) {
  cancelEditAccommodationObjectRoomCategory(
    cancelEditAccommodationObjectRoomCategoryInput: {
      accommodationObjectRoomCategoryCid: $accommodationObjectRoomCategoryCid
    }
  ) {
    status
    errors {
      ...Error
    }
  }
}

mutation AddAccommodationObjectService(
  $applyMethod: ApplyMethod!
  $calculationMethod: CalculationMethodInput!
  $name: [LangStringInput!]!
  $shortName: String!
  $accommodationObjectCid: String!
  $serviceTypeCid: String!
) {
  addAccommodationObjectService(
    addAccommodationObjectServiceInput: {
      accommodationObjectCid: $accommodationObjectCid
      accommodationObjectService: {
        applyMethod: $applyMethod
        calculationMethod: $calculationMethod
        name: $name
        shortName: $shortName
        serviceTypeCid: $serviceTypeCid
      }
    }
  ) {
    serviceView {
      applyMethod
      calculationMethod
      cid
      operations {
        delete
      }
      name {
        langCode
        value
      }
      serviceType {
        cid
        name
        shortName
      }
      shortName
    }
    errors {
      ...Error
    }
  }
}

mutation UpdateAccommodationObjectRoomCategory(
  $accommodationObjectRoomCategoryCid: String!
  $roomTypeCid: String!
  $baseQuantity: UnsignedShort!
  $extQuantity: UnsignedShort!
  $description: [LangStringInput!]!
  $name: [LangStringInput!]!
) {
  updateAccommodationObjectRoomCategory(
    updateAccommodationObjectRoomCategoryInput: {
      accommodationObjectRoomCategoryCid: $accommodationObjectRoomCategoryCid
      roomCategory: {
        description: $description
        name: $name
        roomTypeCid: $roomTypeCid
        seat: { baseQuantity: $baseQuantity, extQuantity: $extQuantity }
      }
    }
  ) {
    roomCategory {
      ...RoomCategoryView
    }
    errors {
      ...Error
    }
  }
}

mutation RemoveAccommodationObjectRoomCategory($accommodationObjectRoomCategoryCid: String!) {
  removeAccommodationObjectRoomCategory(
    input: { accommodationObjectRoomCategoryCid: $accommodationObjectRoomCategoryCid }
  ) {
    status
    errors {
      ...Error
      ...LockResourceError
    }
  }
}

mutation AddContract(
  $contractType: ContractType!
  $accommodationObjectCID: String!
  $legalCid: String!
  $currencyIsoCode: String!
  $legalOrigin: LegalOrigin!
) {
  addContract(
    addContractInput: {
      contractType: $contractType
      accommodationObjectCID: $accommodationObjectCID
      legalCid: $legalCid
      currencyIsoCode: $currencyIsoCode
      legalOrigin: $legalOrigin
    }
  ) {
    Contract {
      ...Contract
    }
    errors {
      ...Error
    }
  }
}

mutation AddAccommodationObject($commonInformation: CommonInformationInput!, $commonContact: CommonContactInput!) {
  addAccommodationObject(
    addAccommodationObjectInput: { commonInformation: $commonInformation, commonContact: $commonContact }
  ) {
    accommodationObject {
      cid
    }
    errors {
      ...Error
    }
  }
}
